import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DataStateChangeEvent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { LedgerService } from 'src/app/shared/service/ledger.service';

declare var require:any;
var moment = require('moment');

@Component({
  selector: 'app-cash-transfer-report',
  templateUrl: './cash-transfer-report.component.html',
  styleUrls: ['./cash-transfer-report.component.scss']
})
export class CashTransferReportComponent implements OnInit {
  filterForm:FormGroup;
  crrno;
  detailsArray:any = [];
  xlsxName;

  public gridData: GridDataResult;
  public state: State = {
    skip: 0,
    take:10,
    filter: {
      logic: 'and',
      filters: []
    }
  };
  public buttonCount = 5;
  public info = true;
  public type: 'numeric' | 'input' = 'numeric';
  public previousNext = true;
  public pageSizes = [200,200,300,400, 500,600,700,800,900,1000, 50000];

  constructor(private fb:FormBuilder, private firestore:AngularFirestore, private ledgerService:LedgerService) { }

  ngOnInit() {
    this.filterForm = this.fb.group({
      from_date: [],
      to_date: []
    });
  }

  onFilterSubmit(){
    this.detailsArray = [];
    let fromDate = this.filterForm.value.from_date;
    let toDate = this.filterForm.value.to_date;

    this.xlsxName = fromDate+'-to-'+toDate;

  

    console.log("Form Value" , fromDate, toDate);
    var collection;
    
  

    var data = {
      'fromDate': fromDate,
      'toDate':toDate,
    }

    this.ledgerService.getCashTransfer(data).then(async response=>{
      if (response.code == 200) {
        this.detailsArray = await response.data;
        console.log("this.detailsArray", await this.detailsArray)
        this.gridData =  await process(this.detailsArray, this.state);
      }
    });
  }

  refresh(){
    location.reload();
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridData = process( this.detailsArray, this.state);
  }

  public pageChange({ skip, take }: PageChangeEvent): void {
    console.log("skip",skip,take )
    this.state.skip = skip;
    this.state.take = take; 
    this.gridData = process( this.detailsArray, this.state);
  }

  public allData = () => {
    return process(this.detailsArray, {
      filter: this.state.filter
    });
  }

}


